import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import {
	PARAM_LABEL_USER
} from 'src/app/core/services/constant/constants.service';
import {
	AbstractControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { Observable, of, Subscriber } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { User } from 'src/app/shared/models/security/user';
import { Profile } from 'src/app/shared/models/security/profile';
import { Service } from 'src/app/shared/models/service';
import { Region } from 'src/app/shared/models/region';

@Component({
	selector: 'app-user-form',
	templateUrl: './user-form.component.html',
	styleUrls: ['./user-form.component.scss']
})
export class UserFormComponent implements OnInit {
	/**
	 * User
	 */
	@Input() user: User;

	/**
	 * Vrai si formulaire d'ajout, faux sinon (formulaire de détail)
	 */
	@Input() isAddForm: boolean;

	/**
	 * Addresse sélectionner dans le typeahead
	 */
	@Input() isAddressSelected: { value: boolean };

	/**
	 * Booleen indiquant si il s'agit de l'addresse par défaut ou non
	 */
	@Input() isAddressDefault: { value: boolean };

	/**
	 * Formulaire angular
	 */
	@Input() form: FormGroup;

	/**
	 * Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	 */
	@Input() isValidateButtonClicked: { value: boolean };

	/**
	 * Signal émis lors de l'envoi du formulaire pour que la sauvegarde du formulaire ce fasse dans le composant parent
	 */
	@Output() sendForm: EventEmitter<any> = new EventEmitter();

	/**
	 * Signal émis pour que la modal soit fermée
	 */
	@Output() hideModal: EventEmitter<any> = new EventEmitter();

	LABEL_USER: string;
	MAX_NAME_CHAR = 25;

	/**
	 * Addresse selectionner
	 */
	selectedaddress?: Address;

	/**
	 * Typeahead des adresse en chargement
	 */
	typeaheadLoading?: boolean;

	/**
	 * Liste des adresse disponibles dans le typeahead
	 */
	addressList: Observable<NominatimResponse[]>;

	/**
	 * Liste des adresse récupérer grace au backend
	 */
	searchResults: NominatimResponse[];

	isPreferencesActive = false;
	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isAreaActive = false;

	/**
	 * Liste des rôles
	 */
	listProfile: Profile[];
	listProfileMapped = []; // list pour le typeahead sous forme {name:nom_employee,object:employee}

	listProfiles: Profile[] = [];

	listSelectedService: Service[];
	listService: Service[];

	listSelectedRegion: Region[];
	listRegion: Region[] = [];

	constructor(
		private facade: FacadeService,
		private logger: LogService,
		private cache: CacheService
	) {
	
	}

	ngOnInit(): void {
		if (this.user) {
			this.listSelectedService = this.user.services != null ? [...this.user.services] : [];
			this.listSelectedRegion = this.user.regions != null ? [...this.user.regions] : [];

			this.listSelectedService.forEach(e => {
				console.log(e);
				if(e.regions != null && e.regions.length > 1){
					this.listRegion = e.regions;
				}
			})

			this.LABEL_USER =
				this.facade.dataStorageService.getLabelCapitalized(
					PARAM_LABEL_USER
			);

			this.facade.serviceService.getAllService().subscribe({
				next: (val) => {
					this.listService = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.getAllProfilesAndSetProfilesInForm();
		}
	}

	isServiceCheck(spec: Service): boolean {
		return this.listSelectedService?.some(
			(specItfc) => specItfc.id === spec.id
		);
	}

	isRegionCheck(spec: Region): boolean {
		return this.listSelectedRegion?.some(
			(specItfc) => specItfc.id === spec.id
		);
	}

	updateSelectedService(e: any, spe: Service) {
		this.listRegion = [];
		this.listSelectedRegion = [];
		if (e.target.checked) {
			if (!this.listSelectedService.some((z) => z.id === spe.id)) {
				this.listSelectedService.push(spe);
			}
		} else {
			if (this.listSelectedService.some((z) => z.id === spe.id)) {
				this.listSelectedService = this.listSelectedService.filter(
					(z) => z.id !== spe.id
				);
			}
		}

		this.listSelectedService.forEach(e => {
			if(e.regions != null && e.regions.length > 1){
				this.listRegion = e.regions;
			}
		})
	}

	updateSelectedRegion(e: any, spe: Region) {
		if (e.target.checked) {
			if (!this.listSelectedRegion.some((z) => z.id === spe.id)) {
				this.listSelectedRegion.push(spe);
			}
		} else {
			if (this.listSelectedRegion.some((z) => z.id === spe.id)) {
				this.listSelectedRegion = this.listSelectedRegion.filter(
					(z) => z.id !== spe.id
				);
			}
		}
	}

	/**
	 * Méthode d'envoie de formulaire, si celui est valide stock les données et envoie un signal au composant parent
	 */
	submitForm() {
		if (this.form.valid) {
			this.user.services = this.listSelectedService;
			this.user.regions = this.listSelectedRegion;
			this.user.firstName = this.form.value.firstName;
			this.user.lastName = this.form.value.lastName;
			// if (this.isAddressSelected.value && this.selectedaddress !== null) {
			// 	this.user.address = this.selectedaddress;
			// } else {
			// 	if (!this.isAddressDefault.value) {
			// 		this.user.address.label = this.form.value.address;
			// 	}
			// }
			//this.user.birthDate = this.form.get('birthDate').value;
			this.user.telephone = this.form.get('phone').value;
			this.user.active = this.form.get('active').value;;
			this.user.email = this.form.get('email').value;
			this.user.profile = this.listProfile.find(x => x.id == this.form.get('profile').value); 
			this.user.username = this.form.get('username').value;

			this.sendForm.emit();
		}
	}

	get firstName() {
		return this.form?.get('firstName');
	}
	get lastName() {
		return this.form?.get('lastName');
	}
	// get address() {
	// 	return this.form?.get('address');
	// }
	get active() {
		return this.form.get('active');
	}
	get email() {
		return this.form.get('email');
	}
	get birthDate() {
		return this.form.get('birthDate');
	}
	get phone() {
		return this.form.get('phone');
	}
	get profile() {
		return this.form.get('profile');
	}
	get username() {
		return this.form.get('username');
	}



	typeaheadProfileOnSelect(
		event: TypeaheadMatch,
		position: number
	): void {
			const profileToSet = event.item.object as Profile;
			if (
				this.listProfiles.findIndex(
					(profile) => profile && profile.id === profileToSet.id
				) === -1 )
			 {
				this.listProfiles[position - 1] = profileToSet;
				if (position === 1) {
					this.form.patchValue(
						{ profile: event.item.name },
						{ onlySelf: true }
					);
			} 
		}
	
	}

	getAllProfilesAndSetProfilesInForm() {
		this.facade.profileService.getAllProfiles().subscribe((data) => {
			this.listProfile = data;
			this.listProfileMapped = data.flatMap((e) => {
				return { name: e.name , object: e };
			});
			if (!this.isAddForm) {
				/**
				 * Récupère les données et initialise le formulaire
				 */
				this.form.patchValue({
					firstName: this.user.firstName,
					lastName: this.user.lastName,
					email: this.user.email,
					username: this.user.username,
					//address: this.user.address || '',
					phone: this.user.telephone,
					birthDate: this.user.birthDate, 
					active: this.user.active,
					profile: this.user.profile?.id
				});
				console.log(this.form);
			}
		});
	}

}
